import styled from 'styled-components';
import { Field } from 'formik';

export const StyledField = styled(Field)<{ disabled?: boolean }>`
  background-color: ${({ disabled }) => (disabled ? '#f0f0f0' : '#fff')};
  border: 1px solid
    ${({ disabled }) => (disabled ? '#ccc' : 'rgba(41, 45, 50, 0.25)')};
  border-radius: 6px;
  color: ${({ disabled }) => (disabled ? '#999' : 'inherit')};
  display: block;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  height: 48px;
  font-size: 14px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};

  &.select {
    color: red !important;
  }
`;

export const StyledErrorMessage = styled.div`
  color: red;
  position: absolute;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
  font-size: 13px;
  color: #676a6c;
`;

export const Wrapper = styled.div<{ fullWidth?: boolean }>`
  margin-top: 18px;
  position: relative;
  width: ${(props) => (props.fullWidth ? '100%' : '')};
  &:first-child {
    margin-top: 0;
  }
`;
